import React from "react"
import { ManageAdminsForm } from "../../../components/ManageAdminsForm"

export const ManageAdminsPage = () => {
  return (
    <div>
      <ManageAdminsForm />
    </div>
  )
}
